import { Link } from "react-router-dom";
import "../PageCommon.css";
import "./Service.css";

const SitemapPage = () => {
  return (
    <div className="page__container">
      <div className="page__head">
      </div>
      <div className="page__body">
        <div className="page__label">
          <h2>Sitemap</h2>
        </div>

        <div className="sitelinks">
          
          <ul className="sitelinks__block">
            <h3>General</h3>
            <li><Link className="sitelinks__link" to="/settings">Settings</Link></li>
            <li><Link className="sitelinks__link" to="/me">Profile</Link></li>
            <li><Link className="sitelinks__link" to="/about">About</Link></li>
            <li><Link className="sitelinks__link" to="/user-guide">User Guide</Link></li>
            <li><Link className="sitelinks__link" to="/signin">Sign In</Link></li>
            <li><Link className="sitelinks__link" to="/signup">Sign Up</Link></li>
          </ul>

          <ul className="sitelinks__block">
            <h3>Pavement Design & Analysys</h3>
            <li><Link className="sitelinks__link" to="/dashboard">Dashboard</Link></li>
            <li><Link className="sitelinks__link" to="/pavement-context-basic">Pavement Context (basic)</Link></li>
            <li><Link className="sitelinks__link" to="/pavement-context-custom">Pavement Context (custom)</Link></li>
            <li><Link className="sitelinks__link" to="/concrete-embodied-emission">Concrete Embodied Emission</Link></li>
            <li><Link className="sitelinks__link" to="/asphalt-embodied-emission">Asphalt Embodied Emission</Link></li>
            <li><Link className="sitelinks__link" to="/pavement-design">Pavement Design</Link></li>
            <li><Link className="sitelinks__link" to="/simulation-in-progress">Simulation In Progress</Link></li>
            <li><Link className="sitelinks__link" to="/report">Report</Link></li>
            <li><Link className="sitelinks__link" to="/detailed-report">Detailed Report</Link></li>
          </ul>

          <ul className="sitelinks__block">
            <h3>Auxiliary</h3>
              <li><Link className="sitelinks__link" to="/design-specification">Design Specification</Link></li>
              <li><Link className="sitelinks__link" to="/mnr-schedule">MnR Schedule</Link></li>
              <li><Link className="sitelinks__link" to="/optimisation-and-sensitivity">Optimisation & Sensitivity</Link></li>
              <li><Link className="sitelinks__link" to="/pedegree-matrix">Pedegree Matrix</Link></li>
            <h3>Information</h3>
              <li><Link className="sitelinks__link" to="/info/albedo">Albedo</Link></li>
              <li><Link className="sitelinks__link" to="/info/carbon-uptake">Carbon Uptake</Link></li>
              <li><Link className="sitelinks__link" to="/info/end-of-life">End of Life</Link></li>
              <li><Link className="sitelinks__link" to="/info/initial-emission">Initial Emission</Link></li>
              <li><Link className="sitelinks__link" to="/info/mnr">M&R</Link></li>
              <li><Link className="sitelinks__link" to="/info/pvi-deflection">PVI Deflection</Link></li>
              <li><Link className="sitelinks__link" to="/info/pvi-roughness">PVI Roughness</Link></li>
              <li><Link className="sitelinks__link" to="/info/iri-asphalt">IRI Asphalt Pavement</Link></li>
              <li><Link className="sitelinks__link" to="/info/iri-rigid">IRI Rigid Pavement</Link></li>

          </ul>
        </div>
      </div>
    </div>
  );
}

export default SitemapPage;